import React from 'react';
import {
  FiArrowLeft, FiEdit2, FiTrash2, FiUserCheck,
  FiPhone, FiMail, FiCalendar, FiHash,
} from 'react-icons/fi';
import styles from '../Lead.module.css';
import { fluxoPorId } from '../fluxos';

const STATUS_CLASS = {
  'Aguardando':  'statusNovo',
  'Aprovado':    'statusConvertido',
  'Sem Retorno': 'statusPerdido',
};

function formatarData(iso) {
  const [a, m, d] = iso.split('-');
  return `${d}/${m}/${a}`;
}

function LeadDetalhe({ lead, onVoltar, onEditar, onExcluir }) {
  const statusCls = styles[STATUS_CLASS[lead.status]] ?? '';

  function handleExcluir() {
    if (window.confirm(`Excluir o lead "${lead.nome}"? Esta ação não pode ser desfeita.`)) {
      onExcluir(lead.id);
    }
  }

  return (
    <div className={styles.detalhe}>
      <button className={styles.btnVoltar} onClick={onVoltar}>
        <FiArrowLeft /> Voltar para Leads
      </button>

      <div className={styles.detalheHeader}>
        <div className={styles.detalheInfo}>
          <h1 className={styles.detalheTitulo}>{lead.nome}</h1>
          <p className={styles.detalheEmpresa}>{lead.empresa}</p>
          <span className={`${styles.status} ${statusCls}`}>{lead.status}</span>
        </div>

        <div className={styles.detalheAcoes}>
          <button
            className={styles.btnConverter}
            onClick={() => alert('Funcionalidade em desenvolvimento')}
          >
            <FiUserCheck /> Converter em Cliente
          </button>
          <button className={styles.btnEditarDetalhe} onClick={() => onEditar(lead)}>
            <FiEdit2 /> Editar
          </button>
          <button className={styles.btnExcluir} onClick={handleExcluir}>
            <FiTrash2 /> Excluir
          </button>
        </div>
      </div>

      <div className={styles.detalheCard}>

        <div className={styles.detalheSecao}>
          <p className={styles.detalheSecaoTitulo}>Informações de Contato</p>
          <div className={styles.detalheGrid}>
            <div className={styles.detalheCampo}>
              <span className={styles.detalheCampoLabel}>Nome completo</span>
              <span className={styles.detalheCampoValor}>{lead.nome}</span>
            </div>
            <div className={styles.detalheCampo}>
              <span className={styles.detalheCampoLabel}>Empresa</span>
              <span className={styles.detalheCampoValor}>{lead.empresa || '—'}</span>
            </div>
            {(lead.cnpj || lead.cpf) && (
              <div className={styles.detalheCampo}>
                <span className={styles.detalheCampoLabel}>
                  <FiHash style={{ marginRight: 4 }} />{lead.cnpj ? 'CNPJ' : 'CPF'}
                </span>
                <span className={styles.detalheCampoValor}>{lead.cnpj || lead.cpf}</span>
              </div>
            )}
            <div className={styles.detalheCampo}>
              <span className={styles.detalheCampoLabel}>
                <FiPhone style={{ marginRight: 4 }} />Telefone / WhatsApp
              </span>
              <span className={styles.detalheCampoValor}>{lead.telefone || '—'}</span>
            </div>
            <div className={styles.detalheCampo}>
              <span className={styles.detalheCampoLabel}>
                <FiMail style={{ marginRight: 4 }} />E-mail
              </span>
              <span className={styles.detalheCampoValor}>{lead.email || '—'}</span>
            </div>
            <div className={styles.detalheCampo}>
              <span className={styles.detalheCampoLabel}>
                <FiCalendar style={{ marginRight: 4 }} />Data de cadastro
              </span>
              <span className={styles.detalheCampoValor}>{formatarData(lead.dataCadastro)}</span>
            </div>
            <div className={styles.detalheCampo}>
              <span className={styles.detalheCampoLabel}>Tipo de fluxo</span>
              <span className={styles.detalheCampoValor}>{fluxoPorId(lead.tipoFluxo)?.label || 'Legado (anterior aos fluxos)'}</span>
            </div>
            <div className={styles.detalheCampo}>
              <span className={styles.detalheCampoLabel}>Status</span>
              <span className={`${styles.status} ${statusCls}`}>{lead.status}</span>
            </div>
          </div>
        </div>

        {lead.servicosInteresse.length > 0 && (
          <div className={styles.detalheSecao}>
            <p className={styles.detalheSecaoTitulo}>Serviços de Interesse</p>
            <div className={styles.servicos}>
              {lead.servicosInteresse.map((s) => (
                <span key={s} className={styles.servicoBadge}>{s}</span>
              ))}
            </div>
          </div>
        )}

        <div className={styles.detalheSecao}>
          <p className={styles.detalheSecaoTitulo}>Histórico de Anotações</p>
          <p className={styles.detalheAnotacoes}>
            {lead.anotacoes || 'Nenhuma anotação registrada.'}
          </p>
        </div>

      </div>
    </div>
  );
}

export default LeadDetalhe;
